import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GET_BRAND_OVERVIEW_CARDS_ERROR_LOG: TDatadogErrorLog = {
  from: 'src/modules/brands/common/hooks/use-brand-overview-cards-data/index.ts',
  name: 'Get Brand Overview Cards Data',
  message: 'Failed to fetch brand overview cards data (videos and creators)',
}
